export default __webpack_public_path__ + "static/media/pp-cov.4c7418bf.jpg";